export const EIGHT = '0 4px 5px 0 rgba(9,30,66,0.14), 0 1px 10px 0 rgba(9,30,66,0.14), 0 2px 4px -1px rgba(9,30,66,0.14)';
/**
 * @deprecated
 */

export const COLUMN_SHADOW = position => `linear-gradient(to ${position}, rgba(99, 114, 130, 0) 0px, rgba(9, 30, 66, 0.13) 100%)`;
export const EDGE_SHADOW = position => `linear-gradient(to ${position}, rgba(99, 114, 130, 0) 0px, rgba(9, 30, 66, 0.13) 100%)`;
export const MODAL = {
  Z_INDEX: 100
};
export const LAYOUT = {
  Z_INDEX: 50
};
export const POPOVER = {
  Z_INDEX: 10
};